export const painPoints = [
  {
    emoji: '🧭',
    title: 'Non sai da dove cominciare',
    desc: "L'alfabeto coreano sembra impossibile e sei sopraffatto da dove iniziare. Questo metodo organizza tutto: prima le basi, poi la pratica, poi il conversazionale.",
  },
  {
    emoji: '🔤',
    title: 'Ti blocchi con l’Hangeul (e tutto suona uguale)',
    desc: 'Qui lo impari in modo guidato, così riconosci gli schemi e pronunci con intenzione. Basta confusione tra lettere e suoni simili.',
  },
  {
    emoji: '🧩',
    title: 'Conosci parole casuali ma non riesci a formare frasi',
    desc: 'Impari la struttura base della frase per costruire periodi che hanno davvero senso e inizi a comunicare dal primo giorno.',
  },
  {
    emoji: '💭',
    title: 'Studi ma dimentichi rapidamente',
    desc: 'Ottieni consigli concreti di memorizzazione e routine di ripasso, così ciò che studi resta nel tuo cervello invece di svanire in una settimana.',
  },
  {
    emoji: '🎬',
    title: 'Guardi i K-Drama e non capisci niente',
    desc: 'I sottotitoli fanno tutto il lavoro e non cogli mai una singola parola reale. Qui allena il tuo orecchio con le espressioni che appaiono davvero sullo schermo.',
  },
  {
    emoji: '🔁',
    title: 'Hai iniziato una app e l’hai abbandonata dopo due settimane',
    desc: 'Le serie non sono progresso. Un piano giornaliero di 60 minuti con passi visibili è ciò che ti permette di avanzare fino a capire la tua prima vera conversazione.',
  },
];
